import React from "react";

const Stat_Data_Types = () => {
  return (
    <div>
      <h1>Stat Data Types</h1>
    </div>
  );
};

export default Stat_Data_Types;
